/* luxev-scripts.js — scroll reveal for the Luxevintage clone sections */
(function () {
  'use strict';
  if (window.__luxevInit) { if (window.luxevScan) window.luxevScan(); return; }
  window.__luxevInit = true;
  document.documentElement.classList.add('luxev-js');
  function scan() {
    var els = document.querySelectorAll('.luxev-reveal:not([data-luxev-seen])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.setAttribute('data-luxev-seen', '1'); el.classList.add('is-visible'); });
      return;
    }
    window.__luxevIO = window.__luxevIO || new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          window.__luxevIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { el.setAttribute('data-luxev-seen', '1'); window.__luxevIO.observe(el); });
  }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  window.luxevScan = scan;
})();